module.exports = __webpack_public_path__ + "assets/tool.ce0f6d38.svg";